// extracted by mini-css-extract-plugin
export var externalLink = "_bu-0";
export var internalLinkLabel = "_bu-1";